import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { api, resolveImage } from "@/lib/api";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, label = "Image", testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/admin/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-slate-300">{label}</label>
      <div className="flex items-center gap-3">
        <div className="relative h-20 w-20 shrink-0 overflow-hidden rounded-xl border border-gold/20 bg-obsidian">
          {value ? (
            <>
              <img src={resolveImage(value)} alt="preview" className="h-full w-full object-cover" />
              <button type="button" onClick={() => onChange("")}
                className="absolute right-1 top-1 rounded-full bg-black/70 p-1 text-white hover:bg-red-600" data-testid={`${testid}-remove`}>
                <X className="h-3 w-3" />
              </button>
            </>
          ) : (
            <div className="flex h-full w-full items-center justify-center text-slate-600">
              <Upload className="h-6 w-6" />
            </div>
          )}
        </div>
        <div className="flex-1">
          <button type="button" onClick={() => inputRef.current?.click()} disabled={loading}
            data-testid={`${testid}-btn`}
            className="inline-flex items-center gap-2 rounded-lg border border-gold/30 px-4 py-2 text-sm font-semibold text-gold hover:bg-gold/10 disabled:opacity-50">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
            {loading ? "Uploading..." : "Upload Image"}
          </button>
          <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid={`${testid}-input`} />
          <p className="mt-1.5 text-xs text-slate-500">JPG, PNG, GIF or WEBP. Max 8MB.</p>
        </div>
      </div>
    </div>
  );
}
